import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
export default {
  name: 'viewDashboardDetails',
  props: ['cardName'],
  watch: {
    currentPage1: function() {
      if (this.cardName === 'pendingEmail') {
        this.getPendingEmailData();
      }
    },
    perPage1: function() {
      this.currentPage1 = 1;
      if (this.cardName === 'pendingEmail') {
        this.getPendingEmailData();
      }
    }
  },
  components: {},
  data() {
    return {
      loader: false,
      viewDashDtlsData: [],
      viewDashDtlsFields: [],
      unsubscribe: null,
      perPage1: commonHelper.perPageRecord,
      pageOptions1: commonHelper.getPageOption(),
      totalRows1: null,
      currentPage1: 1,
      downloadpayload: null,
      sortFlag: {
        creationDate: true,
        templateName: false
      },
      arrowDate: false,
      arrowTemName: false,
      orderName: 'CREATION_DATE',
      orderBy: 'DESC',
      showValueSetModal: false,
      emailStatus: {
        text: null,
        value: null
      },
      receiverEmail: null
    };
  },
  created() {
    if (this.cardName === 'pendingEmail') {
      this.viewDashDtlsFields = [
        {
          key: 'email',
          label: 'Receiver Email',
          class: 'text-center'
        },
        {
          key: 'subject',
          label: 'Subject',
          class: 'text-center'
        },
        {
          key: 'template_name',
          label: 'Template Name',
          class: 'text-center'
        },
        {
          key: 'creation_date',
          label: 'Creation Date',
          class: 'text-center'
        },
        {
          key: 'email_sent_status',
          label: 'Email Status',
          class: 'text-center'
        },
        {
          key: 'status_message',
          label: 'Error',
          class: 'text-center'
        }
      ];
      // this.getPendingEmailData();
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'download') {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.downloadpayload };
          downloadpayload._limit = this.totalRows1;
          if (this.cardName === 'pendingEmail') {
            this.downloadExcel.downloadData(
              downloadpayload,
              'adminDashboard/getPendingEmailData',
              'pending-email',
              () => (this.loader = false)
            );
          }
        }
      }
    });
  },
  methods: {
    // 1.0 <Anuj> To conditionally call the API on Search button Click
    searchDetails() {
      if (this.cardName === 'pendingEmail') {
        this.getPendingEmailData();
      }
    },
    // 1.0 <Anuj> To get pending email data
    getPendingEmailData() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        order_by: this.orderBy,
        order_name: this.orderName,
        sent_status: this.emailStatus.value,
        email: this.receiverEmail
      };
      this.downloadpayload = payload;
      this.loader = true;
      this.$store
        .dispatch('adminDashboard/getPendingEmailData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.viewDashDtlsData = result.map(ele => {
              ele.email_sent_status =
                ele.email_sent_status === 'F' ? 'Failure' : 'Ready To Send';
              return ele;
            });
            this.totalRows1 = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.0 <Anuj> use for sorting data on basis of column asc and des
    sortFunc(item) {
      if (item === 'Creation Date Low to High') {
        this.sortFlag = {
          creationDate: true,
          templateName: false
        };
        this.arrowDate = true;
        this.orderBy = 'ASC';
        this.orderName = 'CREATION_DATE';
      } else if (item === 'Creation Date High to Low') {
        this.sortFlag = {
          creationDate: true,
          templateName: false
        };
        this.arrowDate = false;
        this.orderBy = 'DESC';
        this.orderName = 'CREATION_DATE';
      } else if (item === 'Template Name Low to High') {
        this.sortFlag = {
          creationDate: false,
          templateName: true
        };
        this.arrowTemName = true;
        this.orderBy = 'ASC';
        this.orderName = 'template_name';
      } else if (item === 'Template Name High to Low') {
        this.sortFlag = {
          creationDate: false,
          templateName: true
        };
        this.arrowTemName = false;
        this.orderBy = 'DESC';
        this.orderName = 'template_name';
      }
      if (this.cardName === 'pendingEmail') {
        this.getPendingEmailData();
      }
    },
    // 1.0 <Anuj> To open valuset modal
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    // 1.0 <Anuj> To set the value selected valueSet item
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.EMAIL_STATUS) {
        this.emailStatus = {
          text: item.value_meaning,
          value: item.value_code
        };
      }
    },
    // 1.0 <Anuj> To close valueSet modal
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    // 1.0 <Anuj> To clear valuset value
    clearVsetValues(vsetCode) {
      if (vsetCode === this.emailStatus.value) {
        this.emailStatus = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'receiverEmail') {
        this.receiverEmail = null;
      }
    },
    // 1.0 <Anuj> To clear the search filters
    clearFilters() {
      this.emailStatus = {
        text: null,
        value: null
      };
      this.receiverEmail = null;
      if (this.cardName === 'pendingEmail') {
        this.getPendingEmailData();
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
